import React from 'react';
import { useTranslation } from 'react-i18next';
import type { LastModification } from '@/types/diary';
import { formatShortDateTime } from '@/utils/date';
import { joinNonEmpty } from '@/utils/text';

interface Props {
  authorName: string;
  timeCreated: string;
  lastModification: LastModification | null;
}

export const AuthorInfo: React.FC<Props> = ({
  authorName,
  timeCreated,
  lastModification,
}) => {
  const { t } = useTranslation();

  const isEdited =
    !!lastModification &&
    new Date(lastModification.timeModified) > new Date(timeCreated);

  return (
    <div className="text-caption-12 flex flex-col items-end text-right text-subtle-foreground">
      <p>
        {t('diary.homeTask.added', {
          value: joinNonEmpty([authorName, formatShortDateTime(timeCreated)]),
        })}
      </p>
      {isEdited && (
        <p>
          {t('diary.homeTask.edited', {
            value: joinNonEmpty([
              lastModification.authorName,
              formatShortDateTime(lastModification.timeModified),
            ]),
          })}
        </p>
      )}
    </div>
  );
};
